import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderComponent } from 'recompose';

import TimesheetList from './TimesheetList';
import { queryTimesheetsGQL } from '../graphql/index';
import { dispatchSelectTimesheetKey } from '../actions';

const mapStateToProps = (state) => {
  return {
    selectedTimesheetKey: state.timesheetApprovals.currentTimesheetKey,
    supervisorId: state.timesheetApprovals.currentSupervisorId,
  };
};

const mapDispatchToProps = {
  dispatchSelectTimesheetKey,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoTimesheets = branch(
  (props) => { return props.timesheets.length === 0; },
  renderComponent((props) => {
    return (
      <div className="panel panel-default panel-tabbed">
        <div className="panel-body" style={{ textAlign: 'center' }}>
          <h4>Empty</h4>
          <p className="text-muted">No Timesheets Available</p>
        </div>
      </div>
    );
  }),
);


// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(
  withRedux,
  queryTimesheetsGQL,
  withNoTimesheets,
);

export default enhance(TimesheetList);
